import { useState, useEffect } from "react";
import { WithApiAccess } from "../../lib/HigherOrderComponents/WithApiAccess";
import { withHeaderMessages } from "../../higherOrderComponents/WithHeaderMessages";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { LoadingSpinner } from "../../lib/components/LoadingSpinner";
import { FilterMatchMode } from "primereact/api";
import moment from "moment";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";

const DocumentUploadHistory = (props) => {
  const [documentUploadHistory, setDocumentUploadHistory] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState(null);

  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setGlobalFilterValue("");
  };

  useEffect(() => {
    getDocumentUploadHistory();
    initFilters();
  }, []);

  async function getDocumentUploadHistory() {
    try {
      const response = await props.api.get(`/api/documents/history`);
      if (response.status === 200) {
        const data = response.data;
        const history = data.map((d) => {
          return {
            ...d,
            uploaded:
              moment(d.uploaded).clone().format("MM-DD-YYYY hh:mm A") + " ET",
          };
        });
        setDocumentUploadHistory(history);
      }
    } finally {
      setIsLoadingHistory(false);
    }
  }

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-between">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  return (
    <>
      {isLoadingHistory ? (
        <LoadingSpinner />
      ) : (
        <div>
          <DataTable
            value={documentUploadHistory}
            paginator
            showGridlines
            size="small"
            rows={25}
            rowsPerPageOptions={[10, 25, 50, 100]}
            dataKey="id"
            filters={filters}
            globalFilterFields={[
              "customerCode",
              "documentType",
              "originalFileName",
              "uploadedBy",
              "uploaded",
            ]}
            header={header}
            emptyMessage="No document uploads found in the last 90 days."
          >
            <Column field="customerCode" header="Relationship Code" sortable />
            <Column field="documentType" header="Document Type" sortable />
            <Column field="originalFileName" header="Document Name" sortable />
            <Column field="uploadedBy" header="Uploaded By" sortable />
            <Column field="uploaded" header="Uploaded Date" sortable />
          </DataTable>
        </div>
      )}
    </>
  );
};

export default withHeaderMessages(WithApiAccess(DocumentUploadHistory));
